export enum LANGUAGE_CODE_SUPPORTED {
  en = 'en',
  nl = 'nl',
}

export const LANGUAGES = [
  {
    code: LANGUAGE_CODE_SUPPORTED.en,
    label: 'English',
    translationCode: 'language.en',
  },
  {
    code: LANGUAGE_CODE_SUPPORTED.nl,
    label: 'Dutch',
    translationCode: 'language.nl',
  },
];

export const LANGUAGE_CODE: Record<string, LANGUAGE_CODE_SUPPORTED> = {
  ['EN']: LANGUAGE_CODE_SUPPORTED.en,
  ['NL']: LANGUAGE_CODE_SUPPORTED.nl,
};
